export default "__VITE_ASSET__ahdp4Bkc__"